import { Component, inject, model, ChangeDetectionStrategy } from '@angular/core';
import { ITipoPagoData } from '@core/interfaces/entidades/tipoPago.entidad';
import { UiDialog } from '@shared/components/ui';
import { EditarTipoPago } from './editar-tipo-pago/editar-tipo-pago';
import { TipoPagoApiService } from '@core/services/api/tipo-pago-api.service';

@Component({
  selector: 'app-card-tipo-pago',
  imports: [UiDialog, EditarTipoPago],
  templateUrl: './card-tipo-pago.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './card-tipo-pago.css',
})
export class CardTipoPago {
  // servicios
  private tipoPagoApiService = inject(TipoPagoApiService);
  // datos
  modal_editar = model(false);
  tipoPago = model.required<ITipoPagoData>();

  // métodos
  onEditar() {
    this.modal_editar.set(true);
  }
  closeEditarTipoPago(data?: ITipoPagoData) {
    this.modal_editar.set(false);
    if (data) {
      this.tipoPago.set(data);
    }
  }
  toggleStatus() {
    this.tipoPagoApiService.activarDesactivar(this.tipoPago().id).subscribe((data) => {
      this.tipoPago.set(data);
    });
  }
}
